import { RefObject, useEffect } from "react";

export default function useOutsideClick(
    ref: RefObject<HTMLElement | null>,
    callback: () => void,
) {
    const handleClick = (e: MouseEvent) => {
        const target = e.target;
        if (!(target instanceof Node)) return;
        // React commits its re-render before the click reaches document, so an
        // element the click itself removed is already detached by now. It was
        // inside the ref when it was clicked, so it is not an outside click.
        if (!target.isConnected) return;

        if (ref.current && !ref.current.contains(target)) {
            callback();
        }
    };

    useEffect(() => {
        document.addEventListener("click", handleClick);

        return () => {
            document.removeEventListener("click", handleClick);
        };
    });
}
